var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"clipboardTriggerAction clipboardTriggerAction--copy\">\n    Copy selected lines\n    <i class=\"fa fa-clipboard\"></i>\n    <i class=\"fa fa-check\"></i>\n</span>\n<span class=\"clipboardTriggerAction clipboardTriggerAction--insert clipboardTriggerAction--hide\">\n    Insert selected lines\n    <i class=\"fa fa-clipboard\"></i>\n    <i class=\"fa fa-check\"></i>\n</span>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/src/view/selection-copy.hbs
// module id = YQlf
// module chunks = 1